import Layout from "components/layout/Layout";
import { useState } from "react";
import { Collapse } from "react-collapse";

const FAQ_ARR = [
  {
    title: "Can AI content writing replace human writers?",
    key: 1,
    content:
      "AI content writing works by using machine learning algorithms to analyze vast amounts of data, including text, images, and videos, to generate unique and engaging content. The software learns from previous content and can mimic the style and tone of human writers.",
  },
  {
    title: "How does AI content writing work?",
    key: 2,
    content:
      "AI content writing works by using machine learning algorithms to analyze vast amounts of data, including text, images, and videos, to generate unique and engaging content. The software learns from previous content and can mimic the style and tone of human writers.",
  },
  {
    title: "What is AI content writing?",
    key: 3,
    content:
      "AI content writing works by using machine learning algorithms to analyze vast amounts of data, including text, images, and videos, to generate unique and engaging content. The software learns from previous content and can mimic the style and tone of human writers.",
  },
  {
    title: "What are the benefits of using AI content writing?",
    key: 4,
    content:
      "AI content writing works by using machine learning algorithms to analyze vast amounts of data, including text, images, and videos, to generate unique and engaging content. The software learns from previous content and can mimic the style and tone of human writers.",
  },
  {
    title: "Is AI content writing ethical?",
    key: 5,
    content:
      "AI content writing works by using machine learning algorithms to analyze vast amounts of data, including text, images, and videos, to generate unique and engaging content. The software learns from previous content and can mimic the style and tone of human writers.",
  },
  {
    title: "How much does AI content writing cost?",
    key: 6,
    content:
      "AI content writing works by using machine learning algorithms to analyze vast amounts of data, including text, images, and videos, to generate unique and engaging content. The software learns from previous content and can mimic the style and tone of human writers.",
  },
  {
    title: "How accurate is the content generated by AI software?",
    key: 7,
    content:
      "AI content writing works by using machine learning algorithms to analyze vast amounts of data, including text, images, and videos, to generate unique and engaging content. The software learns from previous content and can mimic the style and tone of human writers.",
  },
];

export default function Faq() {
  const [isActive, setIsActive] = useState({
    status: false,
    key: 1,
  });

  const handleToggle = (key) => {
    if (isActive.key === key) {
      setIsActive({
        status: false,
      });
    } else {
      setIsActive({
        status: true,
        key,
      });
    }
  };
  return (
    <>
      <Layout
        headerStyle={1}
        footerStyle={1}
        breadcrumbTitle={
          <>
            Ask <span>Question</span>
          </>
        }
      >
        <section className="faq-area pb-150">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="faq-wrap">
                  <div className="accordion">
                    {FAQ_ARR.map((faq) => (
                      <div
                        className={
                          isActive.key === faq?.key
                            ? "accordion-item active"
                            : "accordion-item"
                        }
                        key={faq?.key}
                      >
                        <h2 className="accordion-header">
                          <button
                            className={
                              isActive.key === faq?.key
                                ? "accordion-button"
                                : "accordion-button collapsed"
                            }
                            type="button"
                            onClick={() => handleToggle(faq?.key)}
                          >
                            {faq?.title}
                          </button>
                        </h2>
                        <Collapse isOpened={isActive.key === faq?.key}>
                          <div
                            className={
                              isActive.key === faq?.key
                                ? "accordion-collapse collapse show"
                                : "accordion-collapse collapse"
                            }
                          >
                            <div className="accordion-body">
                              <p>{faq?.content}</p>
                            </div>
                          </div>
                        </Collapse>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Layout>
    </>
  );
}
